import { Box } from '@mui/material';
import { forwardRef, MouseEvent as ReactMouseEvent } from 'react';

import { COLORS } from '@/styles/tokens/colors';

export const RESIZE_LINE_WIDTH = 4;

interface ResizeLineProps {
  isResizing: boolean;
  onMouseDown: (event: ReactMouseEvent<HTMLDivElement>) => void;
}

export const ResizeLine = forwardRef<HTMLDivElement, ResizeLineProps>(
  ({ isResizing, onMouseDown }, ref) => {
    return (
      <Box
        ref={ref}
        role="separator"
        aria-orientation="vertical"
        onMouseDown={onMouseDown}
        sx={{
          width: RESIZE_LINE_WIDTH,
          cursor: 'col-resize',
          flexShrink: 0,
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            right: 0,
            width: 2,
            height: '100%',
            backgroundColor: isResizing ? COLORS.GRAY[400] : COLORS.GRAY[200],
            transition: 'background-color 0.2s',
          },
          '&:hover::before': {
            backgroundColor: COLORS.GRAY[400],
          },
        }}
      />
    );
  }
);

ResizeLine.displayName = 'ResizeLine';
